import React from 'react';
type IconProps = {
  className?: string;
  strokeWidth?: number;
};
const base = (className = 'w-6 h-6', strokeWidth = 1.5) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 48 48',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  className
});
// 1. Natural results — sparkle / leaf
export const NaturalIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-299">
    <path d="M24 6l3 10 10 3-10 3-3 10-3-10-10-3 10-3z" data-id="element-300" />
    <path d="M38 32l1.5 4 4 1.5-4 1.5-1.5 4-1.5-4-4-1.5 4-1.5z" data-id="element-301" />
    <path d="M10 32l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" data-id="element-302" />
  </svg>;
// 2. Inches less — ruler with downward arrows
export const InchesIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-303">
    <rect x="8" y="18" width="32" height="12" rx="2" data-id="element-304" />
    <path d="M14 18v4M20 18v6M26 18v4M32 18v6" data-id="element-305" />
    <path d="M24 34v6M20 38l4 4 4-4" data-id="element-306" />
  </svg>;
// 3. Recovery time — clock with check
export const RecoveryIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-307">
    <circle cx="24" cy="26" r="14" data-id="element-308" />
    <path d="M24 18v8l5 3" data-id="element-309" />
    <path d="M18 8h12" data-id="element-310" />
    <path d="M16 10l-3-3M32 10l3-3" data-id="element-311" />
  </svg>;
// 4. No anesthesia — shield with checkmark
export const SafeIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-312">
    <path d="M24 6l14 4v12c0 10-6 18-14 22-8-4-14-12-14-22V10z" data-id="element-313" />
    <path d="M17 24l5 5 9-10" data-id="element-314" />
  </svg>;
// 5. No scars — smooth skin (waves with sparkle)
export const SmoothIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-315">
    <path d="M8 18c4-3 8-3 12 0s8 3 12 0 4-3 8 0" data-id="element-316" />
    <path d="M8 28c4-3 8-3 12 0s8 3 12 0 4-3 8 0" data-id="element-317" />
    <path d="M36 8l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" data-id="element-318" />
    <path d="M10 38l1 2 2 1-2 1-1 2-1-2-2-1 2-1z" data-id="element-319" />
  </svg>;
// 6. Flexible financing — card with check
export const FinancingIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-320">
    <rect x="6" y="12" width="36" height="24" rx="3" data-id="element-321" />
    <path d="M6 20h36" data-id="element-322" />
    <path d="M12 28h6" data-id="element-323" />
    <circle cx="34" cy="28" r="4" data-id="element-324" />
    <path d="M32 28l1.5 1.5 3-3" data-id="element-325" />
  </svg>;
export const benefitIconMap: Record<string, React.FC<IconProps>> = {
  natural: NaturalIcon,
  inches: InchesIcon,
  recovery: RecoveryIcon,
  safe: SafeIcon,
  smooth: SmoothIcon,
  financing: FinancingIcon
};